/* unplugin-vue-components disabled */import { render } from "./DiagramEditor.vue?vue&type=template&id=9db44352&scoped=true&ts=true"
import script from "./DiagramEditor.vue?vue&type=script&lang=ts"
export * from "./DiagramEditor.vue?vue&type=script&lang=ts"

import "./DiagramEditor.vue?vue&type=style&index=0&id=9db44352&scoped=true&lang=scss"
import "./DiagramEditor.vue?vue&type=style&index=1&id=9db44352&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9db44352"]])

export default __exports__